// @flow
/** @jsx jsx */

import * as React from 'react';

import { Border, Colors, Zindexes } from '@zapier/theme';
import { css, jsx } from '@emotion/core';

export type HorizontalType = 'left' | 'right';
export type VerticalType = 'above' | 'atBottom' | 'atTop' | 'below';

type Props = {
  children?: React.Node,
  /** Horizontal Position */
  horizontal?: HorizontalType,
  /** is full width? */
  isBlock?: boolean,
  /** customize the role for the dropdown */
  role?: string,
  /** customizes which HTML tag gets rendered */
  tag: string,
  /** Vertical Position */
  vertical?: VerticalType,
  /** Customize the maximum height. */
  maxHeight?: string,
  /** Customize the minimum width. */
  minWidth?: string,
  /** Customize the z-index. */
  zIndex?: number,
};

const horizontalStyles = {
  left: {
    left: 0,
  },
  right: {
    right: 0,
  },
};

const verticalStyles = {
  above: {
    bottom: '100%',
  },
  atBottom: {
    bottom: 0,
  },
  atTop: {
    top: 0,
  },
  below: {
    top: '100%',
  },
};

const dropdownStyles = (props: Props) => {
  return css(
    {
      backgroundColor: Colors.white,
      border: `${Border.size.default} solid ${Border.color.default}`,
      borderRadius: '4px',
      boxShadow: `0 2px 4px rgba(0, 0, 0, 0.2)`,
      listStyle: 'none',
      margin: 0,
      maxHeight: props.maxHeight || '15em',
      overflow: 'auto',
      padding: 0,
      position: 'absolute',
      zIndex: props.zIndex || Zindexes.dropdownMenu,
    },
    props.isBlock && { width: '100%' },
    props.horizontal && horizontalStyles[props.horizontal],
    props.vertical && verticalStyles[props.vertical],
    props.minWidth && {
      minWidth: props.minWidth,
    }
  );
};

// Note: this needs to be a class so we can pass `ref` from outside
/**
 * Note that this component only handles styling. Any dropdown-ish functionality will be
 * kept separate.
 */
class Dropdown extends React.Component<Props, {}> {
  static defaultProps = {
    tag: 'div',
  };

  render() {
    const { props } = this;
    const Tag = props.tag;
    return (
      <Tag css={dropdownStyles(props)} role={props.role}>
        {props.children}
      </Tag>
    );
  }
}

export default Dropdown;
